export interface DemoBookingLinkParams {
  ticketNumber: string
  requesterEmail: string
  requesterName: string
  companyName?: string | null
  requesterPhone?: string | null
  description?: string | null
}

export function buildDemoBookingQuery(params: DemoBookingLinkParams): URLSearchParams {
  const search = new URLSearchParams({
    ticket: params.ticketNumber.trim(),
    email: params.requesterEmail.trim(),
    name: params.requesterName.trim(),
  })

  const companyName = params.companyName?.trim()
  if (companyName) {
    search.set('company', companyName)
  }

  const phone = params.requesterPhone?.trim()
  if (phone) {
    search.set('phone', phone)
  }

  const description = params.description?.trim()
  if (description) {
    search.set('description', description.slice(0, 500))
  }

  return search
}

export function buildDemoScheduleQuery(ticketNumber: string, requesterEmail: string): URLSearchParams {
  return new URLSearchParams({
    ticket: ticketNumber.trim(),
    email: requesterEmail.trim(),
  })
}

export function buildDemoSchedulePath(ticketNumber: string, requesterEmail: string): string {
  return `/demo/schedule?${buildDemoScheduleQuery(ticketNumber, requesterEmail).toString()}`
}

export function buildDemoBookingPath(params: DemoBookingLinkParams): string {
  return buildDemoSchedulePath(params.ticketNumber, params.requesterEmail)
}

export function buildDemoRescheduleQuery(ticketNumber: string, requesterEmail: string): URLSearchParams {
  return new URLSearchParams({
    ticket: ticketNumber.trim(),
    email: requesterEmail.trim(),
  })
}

export function buildDemoReschedulePath(ticketNumber: string, requesterEmail: string): string {
  return `/demo/reschedule?${buildDemoRescheduleQuery(ticketNumber, requesterEmail).toString()}`
}
